@if (zuweisung$ | async; as zuweisung) {
  <div class="page">
    <div class="content page-header">
      <h1 data-qa="page-title">Erhaltener Vorgang</h1>
      <div class="page-actions">
        <a matButton="filled"
           routerLink="/"
           data-qa="uebersicht-button"
        >
          <mat-icon svgIcon="innogy_picto_arrow-left"></mat-icon>
          Zurück zur Übersicht
        </a>
        <a mat-mini-fab
           aria-label="Mail an Ersteller verfassen"
           data-qa="mail-button"
           href="mailto:tnb-portal.ufla@westnetz.de?subject={{emailSubject}}&body={{emailBody}}&cc={{ccEmailAdressen ? ccEmailAdressen.replaceAll(',', ';') : ''}}"
           target="_blank"
        >
          <mat-icon svgIcon="innogy_picto_envelope_at"></mat-icon>
        </a>
        @if (!zuweisung.gelesen) {
          <button
            [disabled]="!canBeResolved(zuweisung)"
            (click)="markDone()"
            matButton="filled"
            data-qa="erledigen-button"
          >
            <mat-icon svgIcon="innogy_picto_check"></mat-icon>
            {{ zuweisung.aufgabe.type | zuweisungErledigenReadable }}
          </button>
        }
      </div>
    </div>
    <div class="content page-content">
      <mat-card class="basisinformationen mat-elevation-z2">
        <div class="background-{{zuweisung.aufgabe.type}}">
          <mat-card-actions>
            <div
              class="type type-{{zuweisung.aufgabe.type}}">{{ zuweisung.aufgabe.type | aufgabeTypeReadable }}
            </div>
          </mat-card-actions>
          <mat-card-title>
            <h2 data-qa="details-zuweisung-name">{{ zuweisung.aufgabe.name }}</h2>
          </mat-card-title>
          <mat-card-actions>
            <div class="details">
              <mat-icon>alarm</mat-icon>
              <span>
              {{ zuweisung.aufgabe.type | aufgabeTypeFristPrefix }}
              :&nbsp;{{ zuweisung.aufgabe.frist | date: 'dd.MM.yyyy' }}
              </span>
            </div>
            <div class="details">
              <mat-icon>playlist_add_check</mat-icon>
              <span>
              {{ zuweisung.gelesen | zuweisungGelesenReadable: zuweisung.aufgabe.type }}
              </span>
            </div>
          </mat-card-actions>
          <mat-card-content>
            <div class="row">
              <div>
                <h3 class="label">Erstellt am</h3>
                <p class="">{{ zuweisung.aufgabe.erstellungsDatum }}</p>
              </div>
              <div>
                <h3 class="label">Erstellt von</h3>
                <p class="">{{ zuweisung.aufgabe.ersteller.name }}</p>
              </div>
            </div>
            <div>
              <h3 class="label">Kurzbeschreibung</h3>
              <p class="description">{{ zuweisung.aufgabe.kurzbeschreibung }}</p>
            </div>
          </mat-card-content>
          @if (dokumente$ | async; as dokumente) {
            @if (dokumente.length > 0) {
              <div class="attachment-table">
                <div>
                  <mat-card-title>
                    <h2>Angehängte Dateien</h2>
                  </mat-card-title>
                  <mat-card-content>
                    <table mat-table data-qa="angehaente-dateien-dokumente"
                           [dataSource]="dokumente"
                    >
                      <tr mat-header-row
                          *matHeaderRowDef="columnsForDocuments"
                      ></tr>
                      <tr mat-row
                          *matRowDef="let even = even; let dokument; columns: columnsForDocuments"
                          [ngClass]="{gray: even}"
                      >
                      </tr>
                      <ng-container matColumnDef="fileName">
                        <th mat-header-cell
                            *matHeaderCellDef
                        >Name des Dokuments
                        </th>
                        <td mat-cell
                            *matCellDef="let dokument;"
                        >
                          <span>{{ dokument.fileName }}</span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="lastModified">
                        <th mat-header-cell
                            *matHeaderCellDef
                        >Hochgeladen am
                        </th>
                        <td mat-cell
                            *matCellDef="let dokument;"
                        >
                          <span>{{ zuweisung.aufgabe.erstellungsDatum }}</span>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="icon">
                        <th mat-header-cell
                            *matHeaderCellDef
                        ></th>
                        <td class="align-right" mat-cell *matCellDef="let dokument;">
                          <div class="dl">
                            @if (!dokument.downloading) {
                              <button mat-mini-fab
                                      aria-label="Download Dokument"
                                      (click)="downloadDocument(zuweisung.aufgabe.id + '', dokument)"
                              >
                                <mat-icon>cloud_download</mat-icon>
                              </button>
                            }
                            @if (dokument.downloading) {
                              <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                            }
                          </div>
                        </td>
                      </ng-container>
                    </table>
                  </mat-card-content>
                </div>
              </div>
            }
          }
        </div>
      </mat-card>
      @if (requiresReply(zuweisung)) {
        <mat-card data-qa="nvnb-added-files-section" class="reply mat-elevation-z2">
          <mat-card-title>
            <h2>Hinzugefügte Dateien</h2>
          </mat-card-title>
          @if (zuweisung.dokumentVorhanden) {
            <div>
              <mat-card-content>
                <p>Die hinzugefügte Datei kann wieder entfernt und eine neue Datei hinzugefügt werden.
                  Eine Datenweitergabe erfolgt erst, nachdem der Vorgang als erledigt gekennzeichnet wurde
                </p>
              </mat-card-content>
              <mat-card-actions>
                @if (replies$ | async; as dokumente) {
                  <div style="width: 100%;">
                    @if (dokumente.length > 0) {
                      <div>
                        <table mat-table class="attachment-table" data-qa="reply-attachment-table"
                               [dataSource]="dokumente"
                        >
                          <tr mat-header-row
                              *matHeaderRowDef="columnsForDocuments"
                          ></tr>
                          <tr mat-row
                              *matRowDef="let even = even; let dokument; columns: columnsForDocuments"
                              [ngClass]="{gray: even}"
                          >
                          </tr>
                          <ng-container matColumnDef="fileName">
                            <th mat-header-cell
                                *matHeaderCellDef
                            >Name des Dokuments
                            </th>
                            <td mat-cell
                                *matCellDef="let dokument;"
                            >
                              <span>{{ dokument.fileName }}</span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="lastModified">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                            >Hochgeladen am
                            </th>
                            <td mat-cell
                                *matCellDef="let dokument;"
                            >
                              <span>{{ dokument.modifiedDate | date }}</span>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="icon">
                            <th mat-header-cell
                                *matHeaderCellDef
                            ></th>
                            <td class="align-right"
                                mat-cell
                                *matCellDef="let dokument;"
                            >
                              <div class="dl">
                                @if (!zuweisung.gelesen && !this.authenticationService.isVnbObserver(this.uflaUser)) {
                                  <button mat-mini-fab
                                          aria-label="Lösche Antwort"
                                          class="button-warn"
                                          (click)="removeReply(dokument.fileName)"
                                  >
                                    <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                                  </button>
                                }
                                @if (!dokument.downloading) {
                                  <button mat-mini-fab
                                          aria-label="Download Antwort"
                                          (click)="downloadReply(zuweisung.id, dokument)"
                                  >
                                    <mat-icon>cloud_download</mat-icon>
                                  </button>
                                }
                                @if (dokument.downloading) {
                                  <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                                }
                              </div>
                            </td>
                          </ng-container>
                        </table>
                      </div>
                    }
                  </div>
                }
              </mat-card-actions>
            </div>
          }
          @if (!zuweisung.dokumentVorhanden) {
            <div>
              <div>
                <mat-card-content>
                  <p>Nachträglich kann die Datei wieder entfernt und eine neue Datei hinzugefügt werden.<br/>
                    Eine Datenweitergabe erfolgt erst, nachdem die Aufgabe als erledigt gekennzeichnet wurde
                  </p>
                </mat-card-content>
                <mat-card-actions>
                  <form #erstelleAufgabeForm="ngForm">
                    <div fxLayout="center">
                      @if (uploading) {
                        <div>
                          <mat-label class="upload-label">Uploading...</mat-label>
                          <mat-progress-bar
                            mode="determinate"
                            [value]="uploadProgress"
                          ></mat-progress-bar>
                        </div>
                      }
                      @if (!uploading) {
                        <ufla-file-upload [multiple]="false"
                                          [validators]="fileValidatorOptions"
                                          [formControl]="filesControl">
                          @if (isFileSizeError()) {
                            <mat-error>Die ausgewählte Datei ist zu groß, die maximale Größe beträgt 150MB.</mat-error>
                          }
                        </ufla-file-upload>
                      }
                      <span class="upload-button">
                        @if (!uploading) {
                          <button
                            (click)="storeReply(zuweisung)"
                            [disabled]="!isFilePresent() || this.authenticationService.isVnbObserver(this.uflaUser)"
                            matButton="filled"
                            type="button"
                            data-qa="hochladen-button"
                          >
                            <mat-icon>cloud_upload</mat-icon>
                            Hochladen
                          </button>
                        }
                      </span>
                    </div>
                  </form>
                </mat-card-actions>
              </div>
            </div>
          }
        </mat-card>
      }
    </div>
  </div>
}

@if (loadError) {
  <div class="page">
    <div class="content page-header">
      <h1 data-qa="page-title">Erhaltener Vorgang</h1>
    </div>
    <div class="content page-content">
      <div data-qa="zuweisung-load-error">
        <p>Der zugewiesene Vorgang konnte nicht geladen werden, bitte später erneut versuchen oder den Support
          kontaktieren.</p>
      </div>
    </div>
  </div>
}
